import { render, staticRenderFns } from "./taskyType.vue?vue&type=template&id=2865edba&scoped=true"
import script from "./taskyType.vue?vue&type=script&lang=js"
export * from "./taskyType.vue?vue&type=script&lang=js"
import style0 from "./taskyType.vue?vue&type=style&index=0&id=2865edba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865edba",
  null
  
)

export default component.exports